import Marquee from "react-fast-marquee";

const WORDS = [
  "Industrial Patterns", "Dies & Tooling", "CNC Machining", "Wooden Patterns",
  "Metal Patterns", "Aluminium", "Custom Engineering", "72,000+ Delivered",
];

export const Ribbon = () => (
  <div className="border-y border-[#DCE1E8] bg-white py-6" data-testid="editorial-marquee">
    <Marquee speed={38} gradient={false} autoFill>
      {WORDS.map((w, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display text-2xl md:text-4xl font-extrabold uppercase tracking-tight text-[#0E1626] px-8">
            {w}
          </span>
          <span className="text-[#1D4ED8] text-2xl md:text-4xl">//</span>
        </span>
      ))}
    </Marquee>
  </div>
);
